/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getComments.defs.js";
export { main as default } from "./getComments.defs.js";
